import {useEffect, useState} from 'react'
import Button from 'components/ui/Button'
import Spinner from 'components/ui/Spinner'
import TextField from 'components/ui/TextField'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import Table, {Order} from 'components/ui/Table'
import {useGetLocationsQuery} from 'services/locations'
import {SearchOutlined} from '@mui/icons-material'
import {useNavigate} from 'react-router-dom'
import {useDebounce} from '@uidotdev/usehooks'
import * as Styles from 'layouts/PrivateLayout.styles'

interface ILocationsProps {
    title?: string
    tableColumns: Array<any>
    showButtons?: boolean
    navigateToLocation?: boolean
    setSelectedLocations?: (array: readonly number[]) => void
    currentLocations?: readonly number[]
}

const Locations: React.FC<ILocationsProps> = ({
                                                  title = 'Location',
                                                  tableColumns = [],
                                                  showButtons = true,
                                                  navigateToLocation = true,
                                                  setSelectedLocations,
                                                  currentLocations = []
                                              }) => {
    const navigate = useNavigate()
    const [searchTerm, setSearchTerm] = useState('')
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [order, setOrder] = useState<Order>('asc')
    const [orderBy, setOrderBy] = useState<any>('name')
    const [filterBy, setFilterBy] = useState<any>('')
    const [selected, setSelected] = useState<readonly number[]>(currentLocations)
    const disabledBlackoutButton = !selected.length
    const debouncedSearchTerm = useDebounce(searchTerm, 300)

    const {data, isLoading, isFetching} = useGetLocationsQuery({
        page,
        filter_by: filterBy,
        sort_by: `${orderBy}-${order}`,
        limit
    })

    const columns = tableColumns

    const handleBlackoutClick = () => {
        navigate('/admin/locations/blackouts', {state: {locations: selected}})
    }

    const handleDetailClick = (id: number) => {
        if (navigateToLocation) {
            navigate(`/admin/locations/${id}`)
        }
    }

    const handleSelected = (value: readonly number[]) => {
        setSelected(value)
        setSelectedLocations?.(value)
    }

    const handleChange = (e: any) => {
        setSearchTerm(e.target.value)
    }

    useEffect(() => {
        const searchHN = async () => {
            if (debouncedSearchTerm) {
                setFilterBy(`name:"*${debouncedSearchTerm}*"`)
            } else {
                setFilterBy('')
            }
        }

        searchHN()
    }, [debouncedSearchTerm])

    return (
        <div>
            <Styles.PageTitleContainer>
                {title}
                <Styles.PageTitleContainerButtons>
                    {showButtons ? (
                        <>
                            <TextField
                                id="filter-name"
                                className="!w-full sm:!w-60 !h-10"
                                placeholder="Search location"
                                onChange={handleChange}
                                InputProps={{
                                    startAdornment: <SearchOutlined color="disabled"/>
                                }}
                            />
                            {/*<Button*/}
                            {/*  onClick={handleBlackoutClick}*/}
                            {/*  disabled={disabledBlackoutButton}*/}
                            {/*  cc-color="purple"*/}
                            {/*  startIcon={<AddOutlinedIcon />}*/}
                            {/*>*/}
                            {/*  Blackout Period*/}
                            {/*</Button>*/}
                            <Button
                                onClick={() => navigate('/admin/locations/create')}
                                startIcon={<AddOutlinedIcon/>}
                            >
                                Add Location
                            </Button>
                            {/*<Button onClick={() => navigate('/admin/export')}>Export CSV</Button>*/}
                        </>
                    ) : (
                        ''
                    )}
                </Styles.PageTitleContainerButtons>
            </Styles.PageTitleContainer>

            {isLoading ? (
                <Spinner/>
            ) : (
                <Table
                    columns={columns}
                    rows={data?.locations || []}
                    onRowClick={handleDetailClick}
                    selected={selected}
                    setSelected={handleSelected}
                    checkboxSelection
                    isFetching={isFetching || isLoading}
                    emptyTitleText="No locations yet"
                    emptyText="You haven’t added any locations yet."
                    showPagination
                    page={page}
                    setPage={setPage}
                    onPrevPage={() => setPage(page - 1)}
                    onNextPage={() => setPage(page + 1)}
                    order={order}
                    setOrder={setOrder}
                    orderBy={orderBy}
                    setOrderBy={setOrderBy}
                    totalPages={Math.ceil(Number(data?.records_count) / limit)}
                />
            )}
        </div>
    )
}

export default Locations
